import {
    EMPTY_CART,
    REFRESH_CART,
    UPDATE_PACKAGE,
    UPDATE_SINGLE_PRODUCT,
    FETCH_CART_GIFTS
} from '../actions/actionTypes';

export const INITIAL_STATE = {
    id: null,
    packages: [],
    singleProducts: [],
    gifts: [],
    totalPrice: 0,
    zasilkovna: null,
    error: null,
    checkoutError: [],
    cartSaved: false,
    deliveryDate: null
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REFRESH_CART + '_FULFILLED':
            return Object.assign({}, state, action.payload.data.cart);

        case UPDATE_SINGLE_PRODUCT + '_FULFILLED':
            return Object.assign({}, state, action.payload.data.cart);

        case UPDATE_PACKAGE + '_FULFILLED':
            return Object.assign({}, state, action.payload.data.cart);

        case FETCH_CART_GIFTS + '_FULFILLED':
            return { ...state, gifts: action.payload.data };

        case EMPTY_CART:
            return { ...INITIAL_STATE, baseBoxPriceVat: state.baseBoxPriceVat };

        default:
            return state;
    }
}
